import { useMutation, useQueryClient } from '@tanstack/react-query';

import useCurrentBrand from '~/hooks/useCurrentBrand';

import { updateAgency } from '~/services/AgentHub/AgentService';

import { EditAgencyParams } from '~/types/services/agentHub';

import { agencyQueryKeys } from './useGetAgency';
import { agenciesQueryKeys } from './useListAgencies';

interface UpdateAgencyVariables {
  agencyId: string;
  data: EditAgencyParams;
}

interface UseUpdateAgencyOptions {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export function useUpdateAgency(options: UseUpdateAgencyOptions = {}) {
  const queryClient = useQueryClient();
  const brand = useCurrentBrand();
  return useMutation({
    mutationFn: async ({ agencyId, data }: UpdateAgencyVariables) => {
      return await updateAgency(agencyId, data);
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: agenciesQueryKeys.all });
      queryClient.invalidateQueries({ queryKey: agencyQueryKeys.detail(variables.agencyId, brand) });
      options.onSuccess?.();
    },
    onError: (error: Error) => {
      options.onError?.(error);
    },
  });
}
